import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialDesignModule } from './material-design/material-design.module';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { CookieSettingsComponent } from './cookie-settings/cookie-settings.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { WebcamModule } from 'ngx-webcam';
import { SharedModule } from './shared/shared.module';
import { TokenInterceptor } from './interceptor/token.interceptor';
// import { WhyTopRatedComponent } from './why-top-rated/why-top-rated.component';
import { WhatareweofferingModule } from './whatareweoffering/whatareweoffering.module';
import { SelectLocationComponent } from './select-location/select-location.component';
import { ConfidentialScreenComponent } from './components/confidential-screen/confidential-screen.component';
import { NotificationComponent } from './notification/notification.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { EditorComponent } from './editor/editor.component';


@NgModule({
    declarations: [
        AppComponent,
        ChatbotComponent,
        SelectLocationComponent,
        ConfidentialScreenComponent,
        NotificationComponent,
        OtpVerificationComponent,
        EditorComponent,
        // WhyTopRatedComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FlexLayoutModule,
        MaterialDesignModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        WebcamModule,
        NgxSpinnerModule.forRoot(),
        WhatareweofferingModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        CookieService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
